import React, { useState, useContext, useEffect } from 'react'
import FieldsView from '@/product/components/organisms/User/FieldsView'
import { dateTimeFormatFunction } from '@/product/common/components'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import Layout from '@/product/components/templates/Layout'
import { useHistory } from 'react-router-dom'
import * as Yup from 'yup'
import AuthContext from '@/product/context/auth/authContext'

const UserCommon = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const authContext = useContext(AuthContext)
    const { user } = authContext
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        secondaryID: 0,
        user_type: 0,
    })
    const history = useHistory()

    const { user_dynamicfields } = dynamicContext

    const [updatedValues, setUpdatedValues] = useState({})

    const [fieldValue, setFieldValue] = useState([])

    const customInitial = {
        id: 0,
        admin: 1,
    }

    useEffect(() => {
        if (user?.user_id) {
            setManage({
                popup: true,
                status: 'edit',
                id: user?.user_id,
                user_type: 0,
                // secondaryID: props?.match?.params?.sid,
            })
        }
    }, [user?.user_id])

    const customValidation = {
        resale_certificate: Yup.array().when('tax_number', {
            is: (end) => end && end.length > 0,
            then: Yup.array().required('Required!'),
        }),
        ein_no: Yup.string()
            .min(5, 'Minimum 5 characters')
            .max(20, 'Maximum 20 characters')
            .required('Required'),
        phone: Yup.string()
            .trim()
            .min(10, (obj) => {
                if (obj?.value?.length) {
                    return 'Phone must be 10 digits'
                }
            })
            .max(10, (obj) => {
                if (obj?.value?.length) {
                    return 'Phone must be 10 digits'
                }
            })
            .required('Required'),
        additional_phone: Yup.string()
            .trim()
            .nullable()
            .min(10, (obj) => {
                if (obj?.value?.length) {
                    return 'Phone must be 10 digits'
                }
            })
            .max(10, (obj) => {
                if (obj?.value?.length) {
                    return 'Phone must be 10 digits'
                }
            })
            .when('phone', {
                is: (value) => value && value.length === 10,
                then: Yup.string()
                    .nullable()
                    .notOneOf(
                        [Yup.ref('phone')],
                        'Mobile number and additional phone number should not be same'
                    ),
            }),
        phone_type: Yup.string().when('additional_phone', {
            is: (value) => value && value.length === 10,
            then: Yup.string().required('Required!'),
        }),
        license_expiry_date: Yup.date()
            .nullable()
            .min(
                new Date(),
                'Please select a date not earlier than current date'
            )
            .required('Required'),
    }

    useEffect(() => {
        if (user_dynamicfields && user_dynamicfields.length) {
            // console.log(user_dynamicfields, 'userr')
            // let dynamicValueAssign = []
            // user_dynamicfields.map((item) => {
            //     item.view_on
            //         ? item.view_on.includes('4')
            //             ? dynamicValueAssign.push(item)
            //             : {}
            //         : dynamicValueAssign.push(item)
            // })
            // dynamicValueAssign.push({
            //     name: 'market_status',
            //     value: 'draft',
            //     type: 'default',
            //     active: 1,
            // })
            // let temp = dynamicValueAssign.filter((item) => {
            //     return (
            //         item.name != 'password' &&
            //         item.name != 'confirm_password' &&
            //         item.for_organization === 1
            //     )
            // })
            // temp.map((data) => {
            //     if (data.name == 'phone' || data.name == 'additional_phone') {
            //         data.formatPhone = true
            //     }
            // })
            const sellerFields = [
                {
                    id: 49,
                    view_page: '3',
                    field_group: null,
                    label: 'First Name *',
                    diff_name: 0,
                    placeholder: 'Enter your First Name',
                    type: 'text',
                    name: 'first_name',
                    show_order: 1,
                    is_default: 1,
                    is_required: 1,
                    class: 'col-sm-6 col-12',
                    date_disable_past: 0,
                    accept: null,
                    multiple: 0,
                    object_image: 0,
                    folder: null,
                    for_organization: 1,
                    for_buyer: 1,
                    is_deletable: 1,
                    sub_select: 0,
                    sub_level: 0,
                    sub_field: null,
                    country: 0,
                    location: 0,
                    state: 0,
                    default_group: null,
                    active: 1,
                    reorder: null,
                    search: 0,
                    search_type: null,
                    icon_only: 0,
                    is_compress: 0,
                    compress_quality: 0,
                    compress_width: 0,
                    compress_height: 0,
                    diff_value: 0,
                    show_asin: 0,
                    show_group: 0,
                    view_on: '1,2,3,4,7,8,9',
                },
                {
                    id: 50,
                    view_page: '3',
                    field_group: null,
                    label: 'Last Name *',
                    diff_name: 0,
                    placeholder: 'Enter your Last Name',
                    type: 'text',
                    name: 'last_name',
                    show_order: 2,
                    is_default: 1,
                    is_required: 1,
                    class: 'col-sm-6 col-12',
                    date_disable_past: 0,
                    accept: null,
                    multiple: 0,
                    object_image: 0,
                    folder: null,
                    for_organization: 1,
                    for_buyer: 1,
                    is_deletable: 1,
                    sub_select: 0,
                    sub_level: 0,
                    sub_field: null,
                    country: 0,
                    location: 0,
                    state: 0,
                    default_group: null,
                    active: 1,
                    reorder: null,
                    search: 0,
                    search_type: null,
                    icon_only: 0,
                    is_compress: 0,
                    compress_quality: 0,
                    compress_width: 0,
                    compress_height: 0,
                    diff_value: 0,
                    show_asin: 0,
                    show_group: 0,
                    view_on: '1,2,3,4,7,8,9',
                },
                {
                    id: 54,
                    view_page: '3',
                    field_group: null,
                    label: 'Email Address *',
                    diff_name: 1,
                    placeholder: 'Enter your Email Address',
                    type: 'email',
                    name: 'email',
                    show_order: 3,
                    is_default: 1,
                    is_required: 1,
                    class: 'col-sm-6 col-12',
                    date_disable_past: 0,
                    accept: null,
                    multiple: 0,
                    object_image: 0,
                    folder: null,
                    for_organization: 1,
                    for_buyer: 1,
                    is_deletable: 1,
                    sub_select: 0,
                    sub_level: 0,
                    sub_field: null,
                    country: 0,
                    location: 0,
                    state: 0,
                    default_group: null,
                    active: 1,
                    reorder: null,
                    search: 0,
                    search_type: null,
                    icon_only: 0,
                    is_compress: 0,
                    compress_quality: 0,
                    compress_width: 0,
                    compress_height: 0,
                    diff_value: 0,
                    show_asin: 0,
                    show_group: 0,
                    view_on: '1,2,3,4,7,8,9',
                },
                {
                    id: 61,
                    view_page: '3',
                    field_group: null,
                    label: 'Company / Organization',
                    diff_name: 1,
                    placeholder: 'Enter your Organization',
                    type: 'text',
                    name: 'companyname',
                    show_order: 4,
                    is_default: 1,
                    is_required: 1,
                    class: 'col-sm-6 col-12',
                    date_disable_past: 0,
                    accept: null,
                    multiple: 0,
                    object_image: 0,
                    folder: null,
                    for_organization: 1,
                    for_buyer: 1,
                    is_deletable: 1,
                    sub_select: 0,
                    sub_level: 0,
                    sub_field: null,
                    country: 0,
                    location: 0,
                    state: 0,
                    default_group: null,
                    active: 1,
                    reorder: null,
                    search: 0,
                    search_type: null,
                    icon_only: 0,
                    is_compress: 0,
                    compress_quality: 0,
                    compress_width: 0,
                    compress_height: 0,
                    diff_value: 0,
                    show_asin: 0,
                    show_group: 0,
                    view_on: '1,2,3,4,8,9',
                },
                {
                    id: 55,
                    view_page: '3',
                    field_group: null,
                    label: 'Mobile Phone *',
                    diff_name: 0,
                    placeholder: 'Enter your Phone Number',
                    type: 'number',
                    name: 'phone',
                    show_order: 5,
                    is_default: 1,
                    is_required: 1,
                    class: 'col-sm-6 col-12',
                    date_disable_past: 0,
                    accept: null,
                    multiple: 0,
                    object_image: 0,
                    folder: null,
                    for_organization: 1,
                    for_buyer: 1,
                    is_deletable: 1,
                    sub_select: 0,
                    sub_level: 0,
                    sub_field: null,
                    country: 0,
                    location: 0,
                    state: 0,
                    default_group: null,
                    active: 1,
                    reorder: null,
                    search: 0,
                    search_type: null,
                    icon_only: 0,
                    is_compress: 0,
                    compress_quality: 0,
                    compress_width: 0,
                    compress_height: 0,
                    diff_value: 0,
                    show_asin: 0,
                    show_group: 0,
                    view_on: '1,2,3,8,4,9',
                    formatPhone: true,
                },
                {
                    id: 281,
                    view_page: '3',
                    field_group: null,
                    label: 'Mailing / Personal Address',
                    diff_name: 0,
                    placeholder: 'Mailing / Personal Address',
                    type: 'misc',
                    name: 'mailing__personal_address',
                    show_order: 10,
                    is_default: 0,
                    is_required: 0,
                    class: 'col-12 profile-form-title',
                    date_disable_past: 0,
                    accept: null,
                    multiple: 0,
                    object_image: 0,
                    folder: null,
                    for_organization: 1,
                    for_buyer: 1,
                    is_deletable: 1,
                    sub_select: 0,
                    sub_level: 0,
                    sub_field: null,
                    country: 0,
                    location: 0,
                    state: 0,
                    default_group: null,
                    active: 1,
                    reorder: 0,
                    search: 0,
                    search_type: 'select type',
                    icon_only: 0,
                    is_compress: 0,
                    compress_quality: 0,
                    compress_width: 0,
                    compress_height: 0,
                    diff_value: 0,
                    show_asin: 0,
                    show_group: 0,
                    view_on: '',
                },
                {
                    id: 52,
                    view_page: '3',
                    field_group: null,
                    label: 'Address *',
                    diff_name: 1,
                    placeholder: 'Enter your address',
                    type: 'text',
                    name: 'address1',
                    show_order: 11,
                    is_default: 1,
                    is_required: 1,
                    class: 'col-sm-6 col-12',
                    date_disable_past: 0,
                    accept: null,
                    multiple: 0,
                    object_image: 0,
                    folder: null,
                    for_organization: 1,
                    for_buyer: 1,
                    is_deletable: 1,
                    sub_select: 0,
                    sub_level: 0,
                    sub_field: null,
                    country: 0,
                    location: 0,
                    state: 0,
                    default_group: null,
                    active: 1,
                    reorder: null,
                    search: 0,
                    search_type: null,
                    icon_only: 0,
                    is_compress: 0,
                    compress_quality: 0,
                    compress_width: 0,
                    compress_height: 0,
                    diff_value: 0,
                    show_asin: 0,
                    show_group: 0,
                    view_on: '1,2,3,4,8,9',
                },
                {
                    id: 58,
                    view_page: '3',
                    field_group: null,
                    label: 'Address2',
                    diff_name: 1,
                    placeholder: 'Enter your address',
                    type: 'text',
                    name: 'address2',
                    show_order: 12,
                    is_default: 1,
                    is_required: 0,
                    class: 'col-sm-6 col-12',
                    date_disable_past: 0,
                    accept: null,
                    multiple: 1,
                    object_image: 0,
                    folder: null,
                    for_organization: 1,
                    for_buyer: 1,
                    is_deletable: 1,
                    sub_select: 0,
                    sub_level: 0,
                    sub_field: null,
                    country: 0,
                    location: 0,
                    state: 0,
                    default_group: null,
                    active: 1,
                    reorder: null,
                    search: 0,
                    search_type: null,
                    icon_only: 0,
                    is_compress: 0,
                    compress_quality: 0,
                    compress_width: 0,
                    compress_height: 0,
                    diff_value: 0,
                    show_asin: 0,
                    show_group: 0,
                    view_on: '1,2,3,4,8,9',
                },
                {
                    id: 51,
                    view_page: '3',
                    field_group: null,
                    label: 'City *',
                    diff_name: 0,
                    placeholder: 'Enter your City',
                    type: 'text',
                    name: 'city',
                    show_order: 13,
                    is_default: 1,
                    is_required: 1,
                    class: 'col-sm-6 col-12',
                    date_disable_past: 0,
                    accept: null,
                    multiple: 1,
                    object_image: 0,
                    folder: null,
                    for_organization: 1,
                    for_buyer: 1,
                    is_deletable: 1,
                    sub_select: 0,
                    sub_level: 0,
                    sub_field: null,
                    country: 0,
                    location: 0,
                    state: 0,
                    default_group: null,
                    active: 1,
                    reorder: null,
                    search: 0,
                    search_type: null,
                    icon_only: 0,
                    is_compress: 0,
                    compress_quality: 0,
                    compress_width: 0,
                    compress_height: 0,
                    diff_value: 0,
                    show_asin: 0,
                    show_group: 0,
                    view_on: '1,2,3,4,8,9',
                },
                {
                    id: 57,
                    view_page: '3',
                    field_group: null,
                    label: 'State *',
                    diff_name: 0,
                    placeholder: 'Select your State',
                    type: 'select',
                    name: 'state',
                    show_order: 14,
                    is_default: 1,
                    is_required: 1,
                    class: 'col-sm-6 col-12',
                    date_disable_past: 0,
                    accept: null,
                    multiple: 0,
                    object_image: 0,
                    folder: null,
                    for_organization: 1,
                    for_buyer: 1,
                    is_deletable: 1,
                    sub_select: 0,
                    sub_level: 1,
                    sub_field: null,
                    country: 0,
                    location: 0,
                    state: 1,
                    default_group: null,
                    active: 1,
                    reorder: null,
                    search: 0,
                    search_type: null,
                    icon_only: 0,
                    is_compress: 0,
                    compress_quality: 0,
                    compress_width: 0,
                    compress_height: 0,
                    diff_value: 0,
                    show_asin: 0,
                    show_group: 0,
                    view_on: '1,2,3,4,8,9',
                },
                {
                    id: 56,
                    view_page: '3',
                    field_group: null,
                    label: 'Country *',
                    diff_name: 0,
                    placeholder: 'Select your Country',
                    type: 'select',
                    name: 'country',
                    show_order: 15,
                    is_default: 1,
                    is_required: 1,
                    class: 'col-sm-6 col-12',
                    date_disable_past: 0,
                    accept: null,
                    multiple: 0,
                    object_image: 0,
                    folder: null,
                    for_organization: 1,
                    for_buyer: 1,
                    is_deletable: 1,
                    sub_select: 0,
                    sub_level: 0,
                    sub_field: null,
                    country: 1,
                    location: 0,
                    state: 0,
                    default_group: null,
                    active: 1,
                    reorder: null,
                    search: 0,
                    search_type: null,
                    icon_only: 0,
                    is_compress: 0,
                    compress_quality: 0,
                    compress_width: 0,
                    compress_height: 0,
                    diff_value: 0,
                    show_asin: 0,
                    show_group: 0,
                    view_on: '1,2,3,4,8,9',
                },
                {
                    id: 53,
                    view_page: '3',
                    field_group: null,
                    label: 'Zip Code *',
                    diff_name: 1,
                    placeholder: 'Enter your Zip Code',
                    type: 'number',
                    name: 'zip',
                    show_order: 16,
                    is_default: 1,
                    is_required: 1,
                    class: 'col-sm-6 col-12',
                    date_disable_past: 0,
                    accept: null,
                    multiple: 1,
                    object_image: 0,
                    folder: null,
                    for_organization: 1,
                    for_buyer: 1,
                    is_deletable: 1,
                    sub_select: 0,
                    sub_level: 0,
                    sub_field: null,
                    country: 0,
                    location: 0,
                    state: 0,
                    default_group: null,
                    active: 1,
                    reorder: null,
                    search: 0,
                    search_type: null,
                    icon_only: 0,
                    is_compress: 0,
                    compress_quality: 0,
                    compress_width: 0,
                    compress_height: 0,
                    diff_value: 0,
                    show_asin: 0,
                    show_group: 0,
                    view_on: '1,2,3,4,8,9',
                },
            ]
            setFieldValue(sellerFields)
        }
    }, [user_dynamicfields])

    const closeFunction = () => {
        history.goBack()
    }

    const additionalFieldUpdate = (data) => {
        setUpdatedValues(data)
    }
    return (
        <>
            <Layout>
                <FieldsView
                    fieldValue={fieldValue}
                    customInitial={customInitial}
                    data={manage}
                    function={closeFunction}
                    customValidation={customValidation}
                    formatPhone={true}
                    changePassword={false}
                    phoneField={['phone', 'additional_phone']}
                    additionalFieldUpdate={additionalFieldUpdate}
                    seller={true}
                    standalone={true}
                />
            </Layout>
        </>
    )
}

export default UserCommon
